import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useWallet } from '../../context/WalletContext';
import useRegistration from '../../hooks/useRegistration';
import InlineLoader from './InlineLoader';

export default function RequireRegistered({ children }) {
  const { account } = useWallet();
  const { loading, registered } = useRegistration();
  const location = useLocation();

  if (!account) return <Navigate to="/" replace />;
  if (loading) {
    return (
      <div className="main-content">
        <InlineLoader size="lg" text="Verifying account..." />
      </div>
    );
  }
  if (!registered) {
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');
    const to = ref ? `/register?ref=${ref}` : '/register';
    return <Navigate to={to} replace />;
  }
  return children;
}
